import {Component, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';

@Component({
    template: '',
    standalone: false
})
// tslint:disable-next-line:component-class-suffix
export abstract class Destroyable implements OnDestroy {

  protected destroy$: Subject<boolean> = new Subject();

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
